import type { CartUI } from '@libs/common-node';
import {
    getSingleCommerceStoreById,
    getSingleStoreById,
    logConsoleError,
} from '../../utils';
import { asyncForEach } from './asyncForEach';
import { COMPONENTS, CART_ERROR_MESSAGES } from '../../constants';

export default async function fetchAndMergeStores(
    cart: CartUI
): Promise<CartUI> {
    if (!cart?.fulfillmentGroups?.length) {
        return cart;
    }

    const updatedCart = structuredClone(cart);

    await asyncForEach(updatedCart.fulfillmentGroups, async (group, index) => {
        if (group.storeId) {
            try {
                const store = await getSingleCommerceStoreById(group.storeId);
                if (!store) {
                    throw new Error(
                        'Error getting Single Commerce Store by Id'
                    );
                }
                updatedCart.fulfillmentGroups[index].store = store;

                const storeDetails = await getSingleStoreById(group.storeId);
                if (!storeDetails) {
                    throw new Error('Error getting Single Store by Id');
                }
                updatedCart.fulfillmentGroups[index].storeDetails =
                    storeDetails;
            } catch (e) {
                logConsoleError(JSON.stringify(e), {
                    component: COMPONENTS.CART_PROVIDER,
                    severity: 'MEDIUM',
                    additionalInfo: CART_ERROR_MESSAGES.FETCH_STORES_FAILED,
                });
                updatedCart.fulfillmentGroups[index].store = null;
            }
        }
    });

    return updatedCart;
}
